<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { vOnClickOutside } from '@vueuse/components';
import Icon from 'next/icon/Icon.vue';

defineProps({
  options: { type: Array, default: () => [] },
});

const emit = defineEmits(['add']);

const { t } = useI18n();
const showBlockPicker = ref(false);

const handleAdd = key => {
  emit('add', key);
  showBlockPicker.value = false;
};
</script>

<template>
  <div
    v-on-click-outside="() => (showBlockPicker = false)"
    class="relative print:hidden"
  >
    <button
      class="inline-flex items-center gap-2 px-3 text-sm font-medium text-n-slate-11 hover:!text-woot-600 dark:hover:!text-white transition-all duration-100 ease-out rounded-lg hover:bg-n-alpha-2 h-8 justify-center"
      @click="showBlockPicker = !showBlockPicker"
    >
      <Icon icon="i-lucide-plus" class="size-4" />
      {{ t('PLANNING.SHOW.ADD_ATTRIBUTE_BLOCK') }}
    </button>
    <div
      v-if="showBlockPicker"
      class="absolute bottom-full left-0 w-64 bg-white dark:bg-slate-800 border border-slate-75 dark:border-slate-800 rounded-lg shadow-lg z-50 p-1.5"
    >
      <button
        v-for="option in options"
        :key="option.key"
        class="w-full px-4 py-2 text-left text-sm flex items-center gap-2 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors text-n-slate-12"
        @click="handleAdd(option.key)"
      >
        <Icon :icon="option.icon" class="size-4 opacity-60" />
        {{ option.label }}
      </button>
    </div>
  </div>
</template>
